export default "__VITE_ASSET__66f4f599__$_?inline__"